<template>
  <div>
    <app-spinner v-if="page_loading" />
    <template v-else>
      <AppFlexGrid :rows="[['300px', '300px', '300px']]" margin-bottom="50px">
        <template #col-1-1><HMSearch @input.native="onItemSearch" v-model="filter_search" /></template>
        <template #col-1-2>
          <app-date-picker
            @input="onChangeFilter"
            v-model="filter_dates"
            class="family"
            placeholder="DD / MM / YY"
            range
          />
        </template>
        <template #col-1-3>
          <app-select
            @input="onChangeFilter"
            v-model="filter_source"
            :reduce="item => item.id"
            :options="source_options"
            placeholder="Source"
            class="family"
          />
        </template>
      </AppFlexGrid>
      <HMResListItem
        v-for="(res, index) in reservations"
        :key="res.id"
        :index-num="index"
        :res="res"
      />
      <app-cells position="between" style="max-width: 733px">
        <div>
          <paginate
            @input="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="reservations.length" :page="pagination.page" :limit="40" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getHotelManagementReservationsV2, getHotelManagementSources } from '@/http'
import HMResListItem from '@/views/hotel-management/reservations/list/HMResListItem.vue'
import HMSearch from '@/views/hotel-management/reservations/components/HMSearch.vue'
import debounce from 'lodash/debounce'

export default {
  name: 'HotelManagementReservationsListCancelled',
  components: {HMSearch, HMResListItem},
  data() {
    return {
      page_loading: true,
      filter_search: '',
      filter_source: null,
      filter_dates: [],
      source_options: [],
      reservations: [],
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  created() {
    getHotelManagementSources().then((res) => { this.source_options = res.data })
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      getHotelManagementReservationsV2({
        page: this.pagination.page,
        page_size: 40,
        status: 'cancelled',
        search: this.filter_search,
        source: this.filter_source,
        start_date__gte: this.filter_dates[0],
        end_date__lte: this.filter_dates[1],
      })
        .then(res => {
          this.reservations = res.data.results
          this.pagination.pages = res.data.pages
          this.pagination.count = res.data.count
          this.page_loading = false
        })
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    onChangeFilter() {
      this.filter_search = ''
      this.pagination.page = 1
      this.fetchItems()
    },
    onItemSearch() {
      this.searchItem(this)
    },
    searchItem: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
    }, 350),
  }
}
</script>

<style>

</style>